import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

export interface ExportSettings {
  scale: number;
  background: boolean;
  padding: number;
}

/** Remembered per device so "drag an area" exports use the last chosen settings. */
export const exportSettings = createStore<ExportSettings>(() => ({ scale: 2, background: true, padding: 24 }));
export const setExportSettings = (patch: Partial<ExportSettings>) => exportSettings.setState(patch);
export const useExportSettings = <T>(sel: (s: ExportSettings) => T) => useStore(exportSettings, sel);
